exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nh1 button.edit-by-headline,\nh2 button.edit-by-headline,\nh3 button.edit-by-headline,\nh4 button.edit-by-headline,\nh5 button.edit-by-headline,\nh6 button.edit-by-headline {\n  display: none;\n  appearance: none;\n  -webkit-appearance: none;\n  background: none;\n  border: none;\n  margin: 0 0 0 10px;\n  padding: 0;\n}\nh1:hover button.edit-by-headline,\nh2:hover button.edit-by-headline,\nh3:hover button.edit-by-headline,\nh4:hover button.edit-by-headline,\nh5:hover button.edit-by-headline,\nh6:hover button.edit-by-headline {\n  display: inline-block;\n}\n", ""]);

// exports
